import { render, staticRenderFns } from "./CreateBookerAccount.vue?vue&type=template&id=cfe252b8"
import script from "./CreateBookerAccount.vue?vue&type=script&lang=js"
export * from "./CreateBookerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports